import { render, staticRenderFns } from "./oncecard.vue?vue&type=template&id=44db1529&"
import script from "./oncecard.vue?vue&type=script&lang=js&"
export * from "./oncecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports